import { render, staticRenderFns } from "./GraficaVenta.vue?vue&type=template&id=3c24d6b6"
import script from "./GraficaVenta.vue?vue&type=script&lang=js"
export * from "./GraficaVenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports